module.exports = __webpack_public_path__ + "img/arrow_up_2.a3dc010f.svg";